import { render, staticRenderFns } from "./ChildFolder.vue?vue&type=template&id=2b16e272"
import script from "./ChildFolder.vue?vue&type=script&lang=js"
export * from "./ChildFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports